import { AbstractControl, Validators } from '@angular/forms';
import { Observable, Subscription } from 'rxjs';

export enum ShowLogic {
    ShowOnYes,
    ShowOnNo
}

export class NewClinicalFeedbackFormHelper {
    public static SetVisibilityOfControlsOnBooleanEvent(
        event: Observable<boolean | null>,
        controls: AbstractControl[],
        setVisibility: (visibility: boolean) => void,
        showLogic: ShowLogic
    ): Subscription {
        return event.subscribe(value => {
            let show = false;

            switch (showLogic) {
                case ShowLogic.ShowOnYes:
                    show = value === true;
                    break;

                case ShowLogic.ShowOnNo:
                    show = value === false;
                    break;
            }

            NewClinicalFeedbackFormHelper.UpdateControls(show, controls, setVisibility);
        });
    }

    public static SetVisibilityOfControlsOnDropdownEvent(
        event: Observable<unknown>,
        controls: AbstractControl[],
        setVisibility: (visibility: boolean) => void,
        showOnValueSelected: unknown
    ): Subscription {
        return event.subscribe(value => {
            const show = value === showOnValueSelected;

            NewClinicalFeedbackFormHelper.UpdateControls(show, controls, setVisibility);
        });
    }

    public static getAsteriskIfRequired(formControl: AbstractControl): string {
        if (formControl.hasValidator(Validators.required)) {
            return ' *';
        }
        return '';
    }

    private static UpdateControls(show: boolean, controls: AbstractControl[], setVisibility: (visibility: boolean) => void) {
        if (!controls || controls.length === 0) {
            throw new Error('No controls');
        }

        if (show) {
            setVisibility(true);
            controls.forEach(control => {
                control.enable();
            });
        } else {
            setVisibility(false);
            controls.forEach(control => {
                control.disable();
                control.reset();
            });
        }
    }

    public static GetFormattedPhoneNumber(countryCode: string | null, number: string | null) {
        const formattedPhoneNumber = [];

        if (countryCode !== null) {
            formattedPhoneNumber.push(countryCode);
        }

        if (number !== null) {
            formattedPhoneNumber.push(number);
        }

        return formattedPhoneNumber.join(' ');
    }
}
